export enum EUserGroupTypes {
  Customer,
  Machine,
  Module,
  DigitalApp,
  BihlerDigital
}

